export default "__VITE_ASSET__DEX161SZ__"